// extracted by mini-css-extract-plugin
module.exports = {"PropertyContacts":"PropertyContacts_PropertyContacts__1NXr7","contact":"PropertyContacts_contact__PlmS8"};